
<template>
  <div class="twui-hovermenu" v-show="langOpen==='on'">
    <a @click="changeLangEvent('en_US')" v-show="lang === 'zh_CN'">中文</a>
    <a @click="changeLangEvent('zh_CN')" v-show="lang === 'en_US'">English</a>
  </div>
</template>

<script>
import utils from '@/config/cookieUtils'

export default {
  name: 'TwLang',
  data () {
    return {
      currentLangText: '',
      lang: 'zh_CN',
      langOpen: 'on'
    }
  },
  created: function () {
    this.initLang()
  },
  methods: {
    // 初始化语言
    initLang: function () {
      let vm = this
      vm.lang = window.localStorage.getItem('tw_i18n_local') || 'zh_CN'
      if (vm.lang === 'en_US') {
        vm.currentLangText = '中文'
      } else {
        vm.currentLangText = 'English'
      }
      console.log(vm.lang)
      vm.$i18n.locale = vm.lang // 关键语句
    },
    changeLangEvent: function (language) {
      this.$confirm(
        this.$i18n.messages[this.$i18n.locale].m.changeLangConfirm,
        this.$i18n.messages[this.$i18n.locale].m.commonTip,
        {
          confirmButtonText:
            this.$i18n.messages[this.$i18n.locale].m.confirmText,
          cancelButtonText: this.$i18n.messages[this.$i18n.locale].m.cancel,
          type: 'warning'
        }
      )
        .then(() => {
          // 切换语言
          this.lang = language
          console.log(this.lang)
          window.localStorage.setItem('tw_i18n_local', this.lang)
          this.$i18n.locale = this.lang // 关键语句
          if (this.lang === 'en-US') {
            this.currentLangText = 'English'
            this.$store.state.lang = 'en-US'
          } else {
            this.currentLangText = '中文'
            this.$store.state.lang = 'zh-CN'
          }
          utils.set('SWITCH_LANG', true)
          window.location.href = ''
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.messages[this.$i18n.locale].m.cancelManual
          })
        })
    }
  }
}
</script>

<style>
.twui-header-right.headerNewsty {
  line-height: 57px;
  padding-top: 3px;
}

.twui-header-right.headerNewsty .twui-hovermenu-body {
  top: 45px;
}
</style>



// WEBPACK FOOTER //
// tw-lang.vue?2877a2ce